/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Evidence_Title_DescInputs */

const en_directory_detail_evidence_title_desc = /** @type {(inputs: Directory_Detail_Evidence_Title_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public claims about this tool, each tagged with a verification status and its cited source.`)
};

const zh_directory_detail_evidence_title_desc = /** @type {(inputs: Directory_Detail_Evidence_Title_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于该工具的公开声明，每条均标注核验状态与引用来源。`)
};

/**
* | output |
* | --- |
* | "Public claims about this tool, each tagged with a verification status and its cited source." |
*
* @param {Directory_Detail_Evidence_Title_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_evidence_title_desc = /** @type {((inputs?: Directory_Detail_Evidence_Title_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Evidence_Title_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_evidence_title_desc(inputs)
	return zh_directory_detail_evidence_title_desc(inputs)
});
export { directory_detail_evidence_title_desc as "directory.detail.evidence_title_desc" }